<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    color="sr_gray"
    dark
    floating
    mobile-breakpoint="991"
    persistent
    width="240"
  >
    <v-list-item two-line>
      <v-img
        src="@/assets/Icon.png"
        width="38"
        height="38"
      />

      <v-list-item-title class="text-center title">
        License Portal
      </v-list-item-title>
    </v-list-item>

    <v-divider class="mx-3 mb-3" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-item
        v-for="(link, i) in links"
        :key="i"
        :to="link.to"
        active-class="primary black--text"
      >
        <v-list-item-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-title v-text="link.text" />
      </v-list-item>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
// Utilities
  import {
    mapMutations,
    mapState
  } from 'vuex'

  export default {
    props: {
      opened: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
    }),

    computed: {
      ...mapState('app', ['color']),
      inputValue: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        }
      },

      links : function() {
        if( this.$store.state.isCurrentUserPowerUser ) {
          return [
              {
                to: '/dashboard',
                icon: 'mdi-view-dashboard',
                text: 'Dashboard'
              },
              {
                to: '/user-profile',
                icon: 'mdi-account',
                text: 'User Profile'
              },
              {
                to: '/admin-dashboard',
                icon: 'mdi-account-details',
                text: 'Manage Users'
              }
            ];
        } else {
          return [
              {
                to: '/dashboard',
                icon: 'mdi-view-dashboard',
                text: 'Dashboard'
              },
              {
                to: '/user-profile',
                icon: 'mdi-account',
                text: 'User Profile'
              }
            ];
        }
      }
    },

    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer'])
    }
  }
</script>
